import { DatePipe, NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { ArchivedItemType } from '@app/v2/event/enums/archived-items.enum'
import { ArchivedItem } from '@app/v2/event/types/archived-item.type'
import { DropdownComponent } from '@app/v2/shared/components/dropdown/dropdown.component'
import { DropdownOption } from '@app/v2/shared/components/dropdown/types/dropdown-option.type'
import { TruncationDetectorDirective } from '@app/v2/shared/directives/truncation-detector.directive'

@Component({
  selector: 'app-mobile-archived-item-card',
  standalone: true,
  imports: [DropdownComponent, NgClass, DatePipe, TruncationDetectorDirective],
  templateUrl: './mobile-archived-item-card.component.html',
  styleUrl: './mobile-archived-item-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileArchivedItemCardComponent {
  public item = input.required<ArchivedItem>()
  public readonly isSelected = input.required<boolean>()
  public archivedItemMenuOptions = input.required<DropdownOption[]>()
  public readonly selectionToggle = output<void>()
  public readonly menuOptionClick = output<{ item: ArchivedItem; option: DropdownOption }>()
  public archivedItemType = ArchivedItemType

  /**
   * Toggle the selected state of the archived item card.
   */
  public toggleSelected(): void {
    this.selectionToggle.emit()
  }

  /**
   * Forward row action menu selection to the parent.
   * @param option {DropdownOption} - The dropdown option.
   * @returns {void} - The void.
   */
  public onMenuOptionClick(option: DropdownOption): void {
    this.menuOptionClick.emit({ item: this.item(), option })
  }
}
